// extracted by mini-css-extract-plugin
module.exports = {"Form":"style-module--Form--133m8","Wrapper":"style-module--Wrapper--1ml91","Title":"style-module--Title--1RC8v"};